"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderOrderLineStatus = void 0;
const renderOrderLineStatus = (status) => {
    let config = {
        color: "bg-blue",
        text_color: "text-white",
        text: "",
    };
    switch (status) {
        case "DRAFT":
            config = {
                color: "bg-grey4",
                text_color: "text-white",
                text: "Draft",
            };
            break;
        case "PENDING":
            config = {
                color: "bg-blue",
                text_color: "text-white",
                text: "Pending",
            };
            break;
        case "URGENT_ACTION_REQUIRED":
            config = {
                color: "bg-orange",
                text_color: "text-white",
                text: "Urgent action required",
            };
            break;
        case "WAITING_TO_SEND":
            config = {
                color: "bg-orange",
                text_color: "text-white",
                text: "Waiting to send",
            };
            break;
        case "WAITING_FOR_CLIENT_TRANSFER_INFO":
            config = {
                color: "bg-orange",
                text_color: "text-white",
                text: "Waiting for client transfer info",
            };
            break;
        case "MISSING_SUPPLIER_EMAIL":
            config = {
                color: "bg-red",
                text_color: "text-white",
                text: "Missing supplier email",
            };
            break;
        case "PENDING_CLIENT_APPROVAL":
            config = {
                color: "bg-orange",
                text_color: "text-white",
                text: "Pending client approval",
            };
            break;
        case "WAITING_FOR_SUPPLIER":
            config = {
                color: "bg-orange",
                text_color: "text-white",
                text: "Waiting for supplier",
            };
            break;
        case "CONFIRMED_PAID":
            config = {
                color: "bg-green",
                text_color: "text-white",
                text: "Confirmed & Paid",
            };
            break;
        case "CONFIRMED":
            config = {
                color: "bg-green",
                text_color: "text-white",
                text: "Confirmed",
            };
            break;
        case "WAITING_FOR_TEE_SHEET": {
            config = {
                color: "bg-blue",
                text_color: "text-white",
                text: "Waiting for tee sheet",
            };
            break;
        }
        case "RATE_REQUESTED":
            config = {
                color: "bg-orange",
                text_color: "text-white",
                text: "Change requested",
            };
            break;
        case "CHANGE_REQUESTED":
            config = {
                color: "bg-orange",
                text_color: "text-white",
                text: "Change requested",
            };
            break;
        case "UPDATE_PENDING":
            config = {
                color: "bg-orange",
                text_color: "text-white",
                text: "Update pending",
            };
            break;
        case "ALTERNATIVE_OFFERED":
            config = {
                color: "bg-blue",
                text_color: "text-white",
                text: "Alternative offered",
            };
            break;
        case "ALTERNATIVE_OFFERED_OVERDUE":
            config = {
                color: "bg-red",
                text_color: "text-white",
                text: "Alternative offered overdue",
            };
            break;
        case "CANCELLED":
            config = {
                color: "bg-black90",
                text_color: "text-white",
                text: "Cancelled",
            };
            break;
        case "CANCELLED_UNAVAILABLE":
            config = {
                color: "bg-black90",
                text_color: "text-white",
                text: "Cancelled - unavailable",
            };
            break;
        case "CANCELLED_REJECTED_BY_CLIENT":
            config = {
                color: "bg-black90",
                text_color: "text-white",
                text: "Cancelled - rejected by client",
            };
            break;
        case "WAITING_FOR_SUPPLIER_OVERDUE":
            config = {
                color: "bg-red",
                text_color: "text-white",
                text: "Waiting for supplier overdue",
            };
            break;
        default:
            config = {
                color: "bg-blue",
                text_color: "text-white",
                text: status,
            };
            break;
    }
    return config;
};
exports.renderOrderLineStatus = renderOrderLineStatus;
